<template>
  <a
    v-if="helpArticle"
    :href="helpLinkUrl"
    target="_blank"
    :class="[
      'signal-help-article-link',
      { dark },
      { 'i-link learn-more': learnMore },
    ]"
    class="d-flex flex-row align-items-center"
  >
    <span v-if="learnMore">Learn more</span>
    <slot v-else>
      <icon-hover symbol="small-solid-question" :size="16"></icon-hover>
    </slot>
  </a>
</template>

<script>
import { sanitizeUrl } from '@braintree/sanitize-url';
import IconHover from '@/V2/components/IconHover';

export default {
  components: { IconHover },
  props: {
    helpArticle: {
      type: String,
      required: true,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    learnMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      helpLinkUrl: sanitizeUrl(
        `https://help.inscribe.ai/en/articles/${this.helpArticle}`,
      ),
    };
  },
};
</script>

<style lang="scss">
.signal-help-article-link {
  color: $color-raven-40;
  font-size: $font-size-secondary;
  height: 20px;

  &.dark {
    color: $color-navy-blue-80;
  }

  &.learn-more {
    width: fit-content;
    padding-right: 0;
    margin-top: 8px;
    font-size: 12px;
    line-height: 16px;
  }
}
</style>
